import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWhiteBg = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 327,
	height: 219,
	viewBox: "0 0 327 219",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M135.195 9.24753L1.59167 296.248C-3.34581 306.854 4.39763 319 16.097 319H331C339.837 319 347 311.837 347 303V41V16C347 7.16344 339.837 0 331 0H149.7C143.479 0 137.821 3.60691 135.195 9.24753Z",
		fill: "white"
	})
});
export default SvgWhiteBg;
